import { createRouter, createWebHistory } from 'vue-router'
import Auth from '../views/LoginView.vue'
import MainView from '../views/MainView.vue'
import store from '../store' // Добавляем импорт store

const routes = [
  {
    path: '/',
    name: 'MainView',
    component: MainView
  },
  {
    path: '/auth',
    component: Auth
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('checkUser')
    .then((response) => {
      if (response === 'error auth' && to.path !== '/auth') {
        next('/auth')
      } else {
        next()
      }
    })
    .catch((error) => {
      console.error('Error during route guard:', error)
      next('/auth') // В случае ошибки направляем на страницу авторизации
    })
})

export default router
